import { createAction } from 'redux-actions';

export const setEditPermisionAutotieout = createAction(
  'SET_EDIT_PERMISSION_AUTOTIEOUT',
);
